'use client';

import {
  Box,
  VStack,
  Text,
  Image,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import StructuredTextParser from '../../app/landing_pages/karma/Components/StructuredTextParser';

export default function AllYouNeedKnow({ sectionContent }) {
  const { desktopVideo, mobileVideo } = sectionContent?.[2] || {};
  const videoSrc = useBreakpointValue({
    base: mobileVideo,
    md: desktopVideo,
  });

  return (
    <Box
      position="relative"
      overflow="hidden"
      color="white"
      background={'#010b57'}
    >
      <Box
        as="video"
        className="vid"
        autoPlay
        muted
        loop
        playsInline
        key={videoSrc}
        position="absolute"
        top="0"
        bottom="0"
        left="0"
        right="0"
      >
        <source src={videoSrc} type="video/x-m4v" />
      </Box>
      <VStack
        maxW="1202px"
        mx="auto"
        position="relative"
        zIndex={1}
        py={{ base: '72px', md: '72px', lg: '160px' }}
        px={'16px'}
      >
        <Text
          fontSize={{ base: '56px', md: '56px', lg: '72px' }}
          fontFamily="FedraSerifDisplayRegular"
          fontWeight={'400'}
          textAlign={'left'}
          w={'full'}
          lineHeight={{ base: '56px', md: '56px', lg: '72px' }}
          pb={{ base: '40px', md: '40px', lg: '64px' }}
        >
          {sectionContent?.[0]?.titleText}
        </Text>

        <SimpleGrid
          columns={{ base: 1, lg: sectionContent?.[1]?.cards?.length }}
          w={'full'}
          px={{ base: '24px', md: '24px', lg: '0px' }}
        >
          {sectionContent?.[1]?.cards?.map((item, idx) => (
            <VStack
              key={idx}
              display={{ base: 'flex', md: 'flex' }}
              align={{ base: 'flex-start', md: 'flex-start' }}
              flexDirection={{ base: 'row', lg: 'column' }}
              py={'24px'}
              pr={{
                base: '14px',
                md: '14px',
                lg:
                  sectionContent?.[1]?.cards?.length === idx + 1
                    ? '0px'
                    : '32px',
              }}
              pl={{ base: '14px', md: '14px', lg: idx === 0 ? '0px' : '32px' }}
              w={{ base: '100%', md: '100%' }}
              minH={{ base: '100%', lg: '224px' }}
              borderLeft={
                idx !== 0 && {
                  base: 'none',
                  lg: '1px solid rgba(255, 255, 255, 0.40)',
                }
              }
              borderTop={
                idx !== 0 && {
                  base: '1px solid rgba(255, 255, 255, 0.20)',
                  lg: 'none',
                }
              }
              backdropFilter={'blur(6.4575px)'}
              gap={{ base: '16px', lg: '0px' }}
            >
              <Image
                src={item?.thumbnail?.url}
                loading="lazy"
                width={{ base: '28px', md: '48px' }}
                height={{ base: '28px', md: '48px' }}
                alt="thumbnail"
              />
              <Box
                h={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
                flexDirection={'column'}
              >
                <Text
                  fontSize={{ base: '18px', md: '24px' }}
                  textTransform="uppercase"
                  letterSpacing={{ base: '2.24px', md: '3.2px' }}
                  lineHeight={{ base: '17px', md: '24px' }}
                  fontFamily="FedraSansStd-book"
                  pt={{ base: '0px', md: '8px' }}
                  className="allSmallCase"
                >
                  {item?.title}
                </Text>
                <StructuredTextParser
                  str={item?.buttonText}
                  sectionContent={item}
                  fontSize={{ base: '14px', md: '20px' }}
                  letterSpacing={{ base: '0.28px', md: '0.4px' }}
                  lineHeight={{ base: '17px', md: '24px' }}
                  fontFamily="FedraSansStd-medium"
                  pt={{ base: '16px', md: '24px' }}
                  mt="0"
                />
              </Box>
            </VStack>
          ))}
        </SimpleGrid>
      </VStack>
      <style global jsx>
        {`
          .vid {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
          .allSmallCase {
            font-variant: all-small-caps;
          }
        `}
      </style>
    </Box>
  );
}
